const menus = [
	{
		name:"一级菜单0",
		path:"/home/index",
		menus:[
			{
				name:"二级菜单0",
				path:"/home/det/index"
			},
			{
				name:"二级菜单0",
				path:"/home/det/:id",
				hideInMenu:true
			}
		]
	},
	{
		name:"一级菜单1",
		path:"/about/index",
	}
]

export default {
	menus
}